import { OktaLogoIcon } from "vega-icons";

import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";

import type { ActivationFlowConfig } from "../activationFlowConfig";

type Props = {
  config: ActivationFlowConfig;
  /** Icon for primary action. Defaults to OktaLogoIcon for IDP flows. Set to null for no icon. */
  primaryActionIcon?: React.ReactNode | null;
};

export const ActivationSuccessScreen = ({
  config,
  primaryActionIcon,
}: Props) => (
  <div className="flex flex-col h-full gap-4 align-center w-full text-text/primary">
    <div className="flex gap-13 flex-grow w-full flex-col justify-center align-center">
      <div className="max-w-lg flex flex-col gap-3">
        <h2 className="mt-6 whitespace-nowrap heading-5">{config.heading}</h2>
        <p className="body-base-regular">{config.body}</p>
      </div>
      {config.primaryAction ? (
        <ThemedButton
          dataTestId={config.primaryAction.dataTestId}
          icon={
            config.showPrimaryActionIcon !== false
              ? (primaryActionIcon ?? <OktaLogoIcon />)
              : undefined
          }
          onClick={config.primaryAction.onClick}
        >
          {config.primaryAction.label}
        </ThemedButton>
      ) : null}
    </div>
  </div>
);
